<template>
    <div>
        <Breadcrumbs main="Admin" submain="Location" title="Camp" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Camp</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="camp_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(area)="row">
                                            <div v-if="row.item.area">
                                                <p>{{ row.item.area.area_name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(district)="row">
                                            <div v-if="row.item.district">
                                                <p>{{ row.item.district.district_name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(country)="row">
                                            <div v-if="row.item.country">
                                                <p>{{ row.item.country.country_name }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div @click="editCamp(data.item)">
                                                    <feather type="edit" size="18px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                                <div>
                                                    <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCamp(data.item.id)" title="Delete"></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Camp Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Camp" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter camp name" v-model="camp.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Country</label>
                            <select class="form-control digits" v-model="camp.country" @change="getDistrict(camp.country)">
                                <option selected disabled>Select a country</option>
                                <option v-for="(country, index) in countries" :key="index" :value="country.id">{{ country.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>District</label>
                            <select class="form-control digits" v-model="camp.district" @change="getArea(camp.district)">
                                <option selected disabled>Select a district</option>
                                <option v-for="(district, index) in districts" :key="index" :value="district.id">{{ district.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Area</label>
                            <select class="form-control digits" v-model="camp.area">
                                <option selected disabled>Select a area</option>
                                <option v-for="(area, index) in areas" :key="index" :value="area.id">{{ area.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Camp Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Camp" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter camp name" v-model="edit_camp.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Country</label>
                            <select class="form-control digits" v-model="edit_camp.country" @change="getDistrict(edit_camp.country)">
                                <option selected disabled>Select a country</option>
                                <option v-for="(country, index) in countries" :key="index" :value="country.id">{{ country.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>District</label>
                            <select class="form-control digits" v-model="edit_camp.district" @change="getArea(edit_camp.district)">
                                <option selected disabled>Select a district</option>
                                <option v-for="( district, index) in districts" :key="index" :value="district.id">{{ district.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Area</label>
                            <select class="form-control digits" v-model="edit_camp.area">
                                <option selected disabled>Select a area</option>
                                <option v-for="(area, index) in areas" :key="index" :value="area.id">{{ area.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Camp Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this camp?</div>
        </b-modal>
    </div>
</template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Camp',
                        sortable: true
                    },
                    {
                        key: 'area',
                        label: 'Area',
                        sortable: true
                    },
                    {
                        key: 'district',
                        label: 'District',
                        sortable: true
                    },
                    {
                        key: 'country',
                        label: 'Country',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                camp: {
                    name: '',
                    country: null,
                    district: null,
                    area: null
                },
    
                edit_camp: {
                    id: null,
                    name: '',
                    country: null,
                    district: null,
                    area: null
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                camp_list: state => state.camp.camp,
                countries: state => state.country.country,
                districts: state => state.district.district,
                areas: state => state.area.area,
                loading: state => state.camp.campLoading,
                error: state => state.camp.campError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("country/fetchCountry")
            this.$store.dispatch("district/fetchDistrict")
            this.$store.dispatch("area/fetchArea")
            this.$store.dispatch("camp/fetchCamp").then(() => {
                this.items = this.camp_list
                this.totalRows = this.camp_list.length;
            });
        },
    
        methods: {
            getDistrict(country_id) {
                this.$store.dispatch("district/fetchDistrictByCountry", country_id)
            },

            getArea(district_id) {
                this.$store.dispatch("area/fetchAreaByDistrict", district_id)
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.camp.name = null
                this.camp.country = null
                this.camp.district = null
                this.camp.area = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("camp/addCamp", {
                    camp: this.camp
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.camp.name = null
                        this.camp.country = null
                        this.camp.district = null
                        this.camp.area = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editCamp(detail) {
                this.edit_camp.id = detail.id ? detail.id : null
                this.edit_camp.name = detail.name ? detail.name : null
                this.edit_camp.area = detail.area ? detail.area.area_id : null
                this.edit_camp.district = detail.district ? detail.district.district_id : null
                this.edit_camp.country = detail.country ? detail.country.country_id : null
            },
    
            resetEditModal() {
                this.edit_camp.name = null
                this.edit_camp.area = null
                this.edit_camp.district = null
                this.edit_camp.country = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("camp/updateCamp", {
                    id: this.edit_camp.id,
                    camp: this.edit_camp
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.edit_camp.name = null
                        this.edit_camp.country = null
                        this.edit_camp.district = null
                        this.edit_camp.area = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteCamp(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("camp/deleteCamp", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    